import moment from "moment-timezone";

const getLessonCharge = (cost, quantity) =>
    cost * Math.max(Number(quantity) || 1, 1);

export function buildLessonPaymentStatusMap(
    lessons,
    studentsBalance,
    referenceTime = moment.utc(),
) {
    const currentTime = moment.utc(referenceTime);
    const lessonsByStudent = new Map();

    lessons.forEach((lesson) => {
        const studentLessons = lessonsByStudent.get(lesson.student_id) || [];
        studentLessons.push(lesson);
        lessonsByStudent.set(lesson.student_id, studentLessons);
    });

    const statuses = new Map();

    lessonsByStudent.forEach((studentLessons, studentId) => {
        const student = studentsBalance[studentId];
        const cost = Number(student?.cost) || 0;
        let remainingBalance = Math.max(Number(student?.balance) || 0, 0);

        studentLessons
            .sort((left, right) => {
                const timeDifference =
                    moment.utc(left.start_time).valueOf() -
                    moment.utc(right.start_time).valueOf();
                return (
                    timeDifference ||
                    String(left.id).localeCompare(String(right.id))
                );
            })
            .forEach((lesson) => {
                const start = moment.utc(lesson.start_time);
                const end = moment.utc(lesson.end_time);

                if (end.isBefore(currentTime)) {
                    statuses.set(lesson.id, "Урок прошёл");
                    return;
                }

                const charge = getLessonCharge(cost, lesson.quantity);
                const isInProgress =
                    start.isSameOrBefore(currentTime) &&
                    end.isSameOrAfter(currentTime);

                if (isInProgress) {
                    statuses.set(lesson.id, "Урок идёт");
                    remainingBalance = Math.max(remainingBalance - charge, 0);
                    return;
                }

                if (cost <= 0) {
                    statuses.set(lesson.id, "Цена не указана");
                    return;
                }

                if (remainingBalance >= charge) {
                    statuses.set(lesson.id, "Оплачено");
                    remainingBalance -= charge;
                    return;
                }

                statuses.set(lesson.id, "Не оплачено");
                remainingBalance = 0;
            });
    });

    return statuses;
}